var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-16"},[_c('EzTable',{attrs:{"data":_vm.connectionRequests,"headers":{
      name: () => _vm.$t('venues.venueNameColumn'),
    },"columns":['name']},on:{"rowClick":_vm.openSingleVenue},scopedSlots:_vm._u([{key:"cell-name",fn:function({ row }){return [_c('VVenueEntityInfo',{attrs:{"venue":row}})]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }